import React, { useMemo, CSSProperties } from 'react';
import { IFilterProps } from 'types/frontend_models/table/IFilterProps';
import { DatePicker } from 'antd';
// import { RangePickerProps } from 'antd/lib/date-picker';
import { Moment, utc } from 'moment';
import { RangeValue, EventValue, PickerMode } from 'rc-picker/lib/interface';
import { IDateRange } from 'types/frontend_models/time/IDateRange';

const { RangePicker } = DatePicker;

interface IMemoProps
{
	allowEmpty: [boolean, boolean],
	picker: PickerMode
}

export enum TableDateRangePickerMode
{
	default = 0,
	month = 1
}

interface IProps extends IFilterProps
{
	defaultValue?: IDateRange // RangeValue<Moment>
	allowEmpty?: [boolean, boolean],
	pickerMode?: TableDateRangePickerMode
	// placeHolder?: string | undefined,
	// defaultValue?: string | string[] | number
}

const outerStyle: CSSProperties = { margin: '0 -11px' };
const innerStyle: CSSProperties = {
	// Enable to see full-width range picker -> has complications
	width: '100%'
};

export function TableDateRangePicker(props: IProps)
{
	function onChange(values: RangeValue<Moment>, formatString: [string, string]): void
	{
		let dateRange: IDateRange = {};
		if (values !== null) {
			const valueRange = values as [EventValue<Moment>, EventValue<Moment>];

			if (valueRange[0] !== null) {
				dateRange.startDate = valueRange[0].toDate();

				// Ugly fix, maybe needs it's own component?
				if (props.pickerMode === TableDateRangePickerMode.month) {
					dateRange.startDate.setDate(1);
				}
			}
			if (valueRange[1] !== null) {
				dateRange.endDate = valueRange[1].toDate();
				// Ugly fix, maybe needs it's own component?
				if (props.pickerMode === TableDateRangePickerMode.month) {
					dateRange.endDate.setDate(1);
				}
			}
		}

		props.setFilter(props.column.id as string, dateRange);
	}

	const defaultValue: RangeValue<Moment> | undefined = useMemo(() =>
	{
		if (props.defaultValue) {
			let rangeValue: [EventValue<Moment>, EventValue<Moment>] = [null, null];
			if (props.defaultValue.startDate) {
				rangeValue[0] = utc(props.defaultValue.startDate);
			}
			if (props.defaultValue.endDate) {
				rangeValue[1] = utc(props.defaultValue.endDate);
			}
			return rangeValue;
		}
	}, [props.defaultValue]);

	const allowEmpty: [boolean, boolean] = useMemo(() =>
	{
		return props.allowEmpty ? props.allowEmpty : [true, false] as [boolean, boolean];
	}, [props.allowEmpty]);

	switch (props.pickerMode) {
		case TableDateRangePickerMode.month: {
			return (
				<div className="table-range-picker" style={outerStyle}>
					<RangePicker
						defaultValue={defaultValue}
						allowEmpty={allowEmpty}
						onChange={onChange}
						bordered={false}
						style={innerStyle}
						picker="month"
					/>
				</div>
			);
		}
		default: {
			return (
				<div className="table-range-picker" style={outerStyle}>
					<RangePicker
						defaultValue={defaultValue}
						allowEmpty={allowEmpty}
						onChange={onChange}
						bordered={false}
						style={innerStyle}
					/>
				</div>
			)
		}
	}
}
